var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column landing_buy_redeem p0 h100"},[(_vm.operation == 'NEW')?_c('div',{staticClass:"h100"},[_c('base-buy-blu',{on:{"maintenanceCheck":_vm.maintenanceCheck}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ca903fa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/private/landing/LandingBuyRedeem.vue
// module id = 846
// module chunks = 2